import store from 'store';

export default (user1) => {
  const user = user1?user1:store.get('user');
  return !!user?.isWXLogin || !! user?.mobile
}
